import { Module, VuexModule, Mutation, Action, getModule } from "vuex-module-decorators";
import store from ".";
import { PreserveState } from "./secure-storage";
import { MusicPlatformModel } from "../models/MusicPlatform";
import { apiConfigService } from "../config/api.config";
import { responseHandler } from "../shared/helpers";
import { genresService } from "../api/genres.api";
import { ConfigurationModel } from "../models/Configuration";

const name = "app";

@Module({
  store,
  name,
  dynamic: true,
  namespaced: true,
  preserveState: PreserveState(name)
})
class AppModule extends VuexModule {
  public musicPlatforms: MusicPlatformModel[] = [];
  public genres: { id: string; name: string; slug: string }[] = [];
  public configuration: Partial<ConfigurationModel> = {};

  @Mutation
  SET_MUSIC_PLATFORMS(data: MusicPlatformModel[]) {
    this.musicPlatforms = data;
  }

  @Mutation
  SET_GENRES(data: { id: string; name: string; slug: string }[]) {
    this.genres = data;
  }

  @Mutation
  SET_CONFIGURATION(data: ConfigurationModel) {
    this.configuration = data;
  }

  @Action({ commit: "SET_MUSIC_PLATFORMS" })
  public async loadMusicPlatforms() {
    const response = await apiConfigService.request().get("admin/music-platforms/stats");
    const output = responseHandler(response);
    return output.data as MusicPlatformModel[];
  }

  @Action({ commit: "SET_GENRES" })
  public async loadGenres() {
    const response = await genresService.getAll({ page: 1, limit: 1000 });
    return response.data;
  }

  @Action({ commit: "SET_CONFIGURATION" })
  public async loadConfiguration() {
    const response = await apiConfigService.request().get("configuration");
    const output = responseHandler(response);
    return output.data;
  }
}

export const appStore = getModule(AppModule);
